import CardButton from 'components/CardButton';
import CardNews from 'components/CardNews';
import React, { useCallback, useEffect, useState } from 'react'
import Slider from "react-slick";
import ArrowButton from 'components/ArrowButton';
import { useNavigate, useParams } from 'react-router-dom';
import { getProfile } from 'services/apiRoutes';
import SkeletonNews from 'skeletons/SkeletonNews';


export default function News() {
   const [news, setNews] = useState();
  const { slug } = useParams();


   const profileAPI = useCallback(async () => {
     const res = await getProfile(slug);
     if (res.error) {
       return res.message;
     } else {
       const { data } = res.data;
       setNews(data.Berita);
     }
   }, [slug]);

   useEffect(() => {
     profileAPI();
   }, [profileAPI]);



  const navigate = useNavigate();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    adaptiveHeight: true,
    arrows: true,
    nextArrow: <ArrowButton right />,
    prevArrow: <ArrowButton />,
    dotsClass: "button__bar",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // arrows:true
        },
      },
    ],
  };
  return (
    <div className="px-5 space-y-16 xl:px-99 mb-60">
      <div className="flex items-center justify-between mt-36 warpperButton ">
        <h1 className="text-base font-bold md:text-3xl ">Berita Terbaru</h1>
        <div className="flex items-center buttonWrapped">
          <CardButton label="Selengkapnya" onClick={() => navigate("berita")} />
        </div>
      </div>

      <Slider {...settings}>
        {news
          ? news.map(
              (item, index) =>
                index <= 5 && (
                  <CardNews
                    gallery
                    img={item?.url_gambar}
                    label={
                      item?.list_kategori_berita_obj[index]
                        ? item?.list_kategori_berita_obj[index]?.kategori_obj
                            ?.nama
                        : ""
                    }
                    title={item?.judul}
                    onClick={() => navigate(`postberita/${item.uuid}`)}
                  />
                )
            )
          : [1, 2, 3, 4].map((x) => <SkeletonNews />)}
      </Slider>
    </div>
  );
}
